
const DOMAIN_PREFIX = {
	// 本地
	// API_PREFIX: "http://localhost:8888/configcloud_war_exploded/",
	// CAMERA_DEPLOYED_PATH: "ws://10.26.68.37:8888/configcloud_war/realplay/",
	// CAMERA_PREFIX: "http://localhost:8888/configcloud_war/",


    // 部署
	API_PREFIX: "https://www.yunkongzutai.cn/configcloud",
	CAMERA_DEPLOYED_PATH: "ws://47.112.168.17:308/configcloud/realplay/",
	CAMERA_PREFIX: "http://d1.caijingshidai.cn:308/configclofindCondud",

	IMG_PREFIX: "/front/",
	
	AVATAR_PREFIX : "https://www.yunkongzutai.cn/configcloud/", //文件前缀
	//AVATAR_PREFIX : "http://localhost:8888/configcloud_war/", //头像前缀
	FRONT_END_PREFIX: "",

	WX_LOGIN_PREFIX: "https://www.yunkongzutai.cn/front/"
}

export default DOMAIN_PREFIX